const CURRENT_VESSEL_KEY = 'naviofit:current-vessel-id';

export function getCurrentVesselId(): string | null {
  try {
    return localStorage.getItem(CURRENT_VESSEL_KEY);
  } catch {
    return null;
  }
}

export function setCurrentVesselId(vesselId: string): void {
  try {
    localStorage.setItem(CURRENT_VESSEL_KEY, vesselId);
  } catch {
    /* storage unavailable - default vessel remains in use */
  }
}
